import { render, staticRenderFns } from "./EnrolmentListPopup.vue?vue&type=template&id=1950b980&scoped=true&"
import script from "./EnrolmentListPopup.vue?vue&type=script&lang=js&"
export * from "./EnrolmentListPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950b980",
  null
  
)

export default component.exports